<template>
    <div class="main-cn">

        <div class="main-hd">
            <h4>审批异常数据管理</h4>
        </div>

        <div class="main-bd mg20">
            <el-tabs class="mg20" v-model="activeName">

                <el-tab-pane label="订单审核不通过统计" name="Orders">

                    <el-row class="order-info-filter">
                        <el-form :inline="true" ref="searchModel" :model="searchModel">
                            <el-form-item label="时间筛选">
                                <el-date-picker
                                        size="small"
                                        v-model="approve_times"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd"
                                        dateType="time"
                                        value-format="timestamp"
                                        align="right"
                                >
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="small" @click="startCount">搜索</el-button>
                            </el-form-item>
                        </el-form>

                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span><b>全部不通过次数合计</b></span>
                            </div>
                            <div class="text item">
                                <el-row>
                                  <el-col :span="8">
                                      <div style="text-align: center;">
                                          <p style="font-size: 34px;font-weight: bold;margin-bottom: 5px">{{sumCount.total_count}}</p>
                                          <p>订单不通过总次数</p>
                                      </div>
                                  </el-col>
                                  <el-col :span="8">
                                      <div style="text-align: center;">
                                          <p style="font-size: 34px;font-weight: bold;margin-bottom: 5px">{{sumCount.finance_count}}</p>
                                          <p>财务信息不通过总次数</p>
                                      </div>
                                  </el-col>
                                  <el-col :span="8">
                                      <div style="text-align: center;">
                                          <p style="font-size: 34px;font-weight: bold;margin-bottom: 5px;">{{sumCount.contract_count}}</p>
                                          <p>合同信息不通过总次数</p>
                                      </div>
                                  </el-col>
                                </el-row>
                            </div>
                        </el-card>

                        <el-row :gutter="15" style="padding: 20px 0px">
                            <el-col :span="12">
                                <el-card class="box-card" style="height: 460px">
                                    <div slot="header" class="clearfix">
                                        <span><b>财务信息不通过原因统计</b></span>
                                    </div>
                                    <div class="text item">
                                        <el-table :data="financeCountData" size="mini" style="width: 100%" class="blue-link">
                                            <el-table-column label="序号" prop="no"></el-table-column>
                                            <el-table-column label="不通过原因" prop="reason_text" width="200"></el-table-column>
                                            <el-table-column label="产生次数" prop="total_count">
                                                <template slot-scope="scope">
                                                    <router-link target="_blank" :to="{path:'/order/audit-log', query:{flow_type: 2, reason: scope.row.reason}}">
                                                        {{ scope.row.total_count}}
                                                    </router-link>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="时间范围" width="200">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row.start_at}} - {{scope.row.end_at}}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="占比">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row.ratio}}%</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-card>

                            </el-col>

                            <el-col :span="12">
                                <el-card class="box-card" style="height: 460px">
                                    <div slot="header" class="clearfix">
                                        <span><b>合同信息不通过原因统计</b></span>
                                    </div>
                                    <div class="text item">
                                        <el-table :data="contractCountData" style="width: 100%" size="mini" class="blue-link">
                                            <el-table-column label="序号" prop="no"></el-table-column>
                                            <el-table-column label="不通过原因" prop="reason_text" width="200"></el-table-column>
                                            <el-table-column label="产生次数" prop="total_count">
                                                <template slot-scope="scope">
                                                    <router-link target="_blank" :to="{path:'/order/audit-log', query:{flow_type: 3, reason: scope.row.reason}}">
                                                        {{ scope.row.total_count}}
                                                    </router-link>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="时间范围" width="200">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row.start_at}} - {{scope.row.end_at}}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="占比">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row.ratio}}%</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>

                        <el-row :gutter="15" style="padding: 5px 0px">
                            <el-col :span="12">

                                <el-card class="box-card">
                                    <div slot="header" class="clearfix">
                                        <span><b>业务组审核不通过次数排名</b></span>
                                    </div>
                                    <div class="text item">

                                        <el-form ref="branchSearchModel" :model="branchSearchModel">
                                            <el-form-item>
                                                <el-radio-group v-model="branchSearchModel.flow_type" size="small">
                                                    <el-radio-button label="2">财务信息</el-radio-button>
                                                    <el-radio-button label="3">合同信息</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>

                                            <el-form-item label="不通过原因">
                                                <el-select v-model="branchSearchModel.reason" size="mini">
                                                    <el-option  label="请选择" value=""></el-option>
                                                    <el-option
                                                            v-for="(reason, key) in getReasons(branchSearchModel.flow_type)"
                                                            :key="key"
                                                            :label="reason"
                                                            :value="key"
                                                    >
                                                    </el-option>
                                                    <el-option  label="其他" value="0"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>

                                        <el-table :data="branchRankData" style="width: 100%" size="mini">
                                            <el-table-column label="排名" prop="no" width="50"></el-table-column>
                                            <el-table-column label="组别" prop="branch_name"></el-table-column>
                                            <el-table-column label="不通过原因" prop="reason_text"></el-table-column>
                                            <el-table-column label="产生次数" prop="total_count"></el-table-column>
                                            <el-table-column label="时间范围" width="200">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row.start_at}} - {{scope.row.end_at}}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>

                                    </div>
                                </el-card>

                            </el-col>

                            <el-col :span="12">
                                <el-card class="box-card">
                                    <div slot="header" class="clearfix">
                                        <span><b>业务员审核不通过次数排名</b></span>
                                    </div>
                                    <div class="text item">

                                        <el-form ref="userSearchModel" :model="userSearchModel">
                                            <el-form-item>
                                                <el-radio-group v-model="userSearchModel.flow_type" size="small">
                                                    <el-radio-button label="2">财务信息</el-radio-button>
                                                    <el-radio-button label="3">合同信息</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>

                                            <el-form-item label="不通过原因">
                                                <el-select v-model="userSearchModel.reason" size="mini">
                                                    <el-option  label="请选择" value=""></el-option>
                                                    <el-option
                                                            v-for="(reason, key) in getReasons(userSearchModel.flow_type)"
                                                            :key="key"
                                                            :label="reason"
                                                            :value="key"
                                                    >
                                                    </el-option>
                                                    <el-option  label="其他" value="0"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>


                                        <el-table :data="userRankData" style="width: 100%" size="mini">
                                            <el-table-column label="排名" prop="no" width="50"></el-table-column>
                                            <el-table-column label="业务员" prop="salesman_name"></el-table-column>
                                            <el-table-column label="不通过原因" prop="reason_text"></el-table-column>
                                            <el-table-column label="产生次数" prop="total_count"></el-table-column>
                                            <el-table-column label="时间范围" width="200">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row.start_at}} - {{scope.row.end_at}}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>

                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>

                    </el-row>

                </el-tab-pane>

                <el-tab-pane label="财务审核不通过记录" name="Finances">
                    <audit-list v-if="activeName == 'Finances'" :reason="queryReason" :flow_type = "2" ></audit-list>
                </el-tab-pane>

                <el-tab-pane label="合同审核不通过记录" name="Contracts">
                    <audit-list v-if="activeName == 'Contracts'" :reason="queryReason" :flow_type = "3"></audit-list>
                </el-tab-pane>

            </el-tabs>

        </div>

    </div>
</template>

<script>

    import AuditList from "~/views/order/approve/auditList.vue";
    import OrderAuditLogService from "~/services/OrderAuditLog";
    import Params from "~/config/params";

    export default {
        name: "AuditLog",
        components: {
            AuditList
        },
        data() {
            return {
                loading: false,
                activeName: 'Orders',
                searchModel: {},
                approve_times: [],
                branchSearchModel: {
                    flow_type: 2, // 默认读取财务审批类型数据
                    reason: '',
                    start_at: '',
                    end_at: '',
                    rank_type: 2,
                },

                userSearchModel: {
                    flow_type: 2, // 默认读取财务审批类型数据
                    reason: '',
                    start_at: '',
                    end_at: '',
                    rank_type: 1,
                },

                sumCount: {
                    total_count: 0,
                    finance_count: 0,
                    contract_count: 0
                },

                financeCountData: [], // 财务统计数据
                contractCountData: [], // 合同统计数据
                userRankData: [], // 用户统计排名数据
                branchRankData: [], // 按部门统计排名数据
                queryReason: '', // URL参数中的审批原因
            };
        },
        created() {
            this.startCount();

            let queryFlowType = this.$route.query['flow_type'];
            let queryReason = this.$route.query['reason'];
            if (queryFlowType != '') {

                if (queryFlowType == 2) {
                    this.activeName = 'Finances';
                }

                if (queryFlowType == 3) {
                    this.activeName = 'Contracts';
                }
            }

            if (queryReason != '') {
                this.queryReason = queryReason;
            }

        },
        watch: {
            "userSearchModel.flow_type": function (value, oldValue) {
                this.getUserRankData();
            },
            "userSearchModel.reason": function (value, oldValue) {
                this.getUserRankData();
            },
            "branchSearchModel.flow_type": function (value, oldValue) {
                this.getBranchRankData();
            },
            "branchSearchModel.reason": function (value, oldValue) {
                this.getBranchRankData();
            },
        },
        methods: {
            handleSwitch() {

            },

            startCount() {
                this.getSumCount();
                this.getFinanceCountData();
                this.getContractCountData();
                this.getUserRankData();
                this.getBranchRankData();
            },

            /**
             * 得到订单综合统计数据
             * */
            getSumCount() {
                let params = {}
                if (this.approve_times.length > 0) {
                    params = {
                        start_at: this.approve_times[0],
                        end_at: this.approve_times[1]
                    };
                }
                OrderAuditLogService.getCountSum(params).then(res => {
                    if (res.code == 0) {
                        this.sumCount = res.data;
                    }
                }).catch(err => {
                    console.error(err);
                })
            },


            getFinanceCountData() {
                this.getReasonCount({flow_type: 2});
            },

            getContractCountData() {
                this.getReasonCount({flow_type: 3});
            },

            /**
             * 按不通过原因统计
             * @param params
             */
            getReasonCount(params) {

                if (this.approve_times.length > 0) {
                    params['start_at'] = this.approve_times[0];
                    params['end_at']  = this.approve_times[1];
                }

                OrderAuditLogService.getReasonCount(params).then(res => {
                    if (res.code == 0) {
                        if (params.flow_type == 2) {
                            this.financeCountData = res.data;
                        }else if (params.flow_type == 3) {
                            this.contractCountData = res.data;
                        }
                    }
                }).catch(err => {
                    console.error(err);
                });
            },

            /**
             * 得到排名统计数据
             **/
            getRankCount(params) {

                if (this.approve_times.length > 0) {
                    params['start_at'] = this.approve_times[0];
                    params['end_at']  = this.approve_times[1];
                }

                OrderAuditLogService.getRankCount(params).then(res => {
                    if (res.code == 0) {
                        if (params.rank_type == 1) {
                            this.userRankData = res.data;
                        }

                        if (params.rank_type == 2) {
                            this.branchRankData = res.data;
                        }
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            /**
             * 得到用户排名统计数据
             */
            getUserRankData() {
                this.getRankCount(this.userSearchModel);
            },

            /**
             * 得到部门排名统计数据
             */
            getBranchRankData() {
                this.getRankCount(this.branchSearchModel);
            },

            getReasons(type) {
                return Params.getReasons(type);
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/approve/auditLog.vue